import { RateFinderResultStatus, RateFinderCriteria, RateFinderResult } from "app/pages/AgentPricing/modules/RateFinderWidget/state";
import { Action, ActionType } from "app/pages/AgentPricing/actionTypes";
import { combineReducers } from "redux";
import { AgentCommissionRateQueryResult, AgentCommissionRateQueryStatus, AgentCommissionRateQueryDto } from "app/shared/model/AgentCommissionDto";

export function criteria(state: RateFinderCriteria|undefined, action: Action) : RateFinderCriteria {
    if (!state) {
        return {
            itemType: undefined,
            itemId: undefined,
            schoolId: undefined
        }
    }

    switch(action.type) {
        case ActionType.ChangeRateFinderCriteria:
            return {
                itemType: action.itemType,
                itemId: action.itemId,
                schoolId: action.schoolId
            }
        default: 
            return state; 
    }
}

export function result(state: RateFinderResult|undefined, action: Action) : RateFinderResult {
    if (!state) {
        return {
            status: RateFinderResultStatus.Empty
        }
    }

    switch(action.type) {
        case ActionType.ChangeRateFinderCriteria: 
            if (action.itemId == undefined && action.schoolId == undefined) {
                return {
                    status: RateFinderResultStatus.Empty
                }
            }
            else 
                return state; 
        case ActionType.RateFinderQueryRunning: 
            return {
                status: RateFinderResultStatus.Running
            }
        case ActionType.RateFinderQueryResult: 
            return MapToRateFinderResult(action.request, action.result); 
        default: 
            return state; 
    }
}

function MapToRateFinderResult(request: AgentCommissionRateQueryDto, result: AgentCommissionRateQueryResult) : RateFinderResult {
    if (result.status === AgentCommissionRateQueryStatus.Errored) {
        return {
            status: RateFinderResultStatus.Errored
        }
    }

    const isProductSelected = request.itemId !== undefined && request.itemType !== undefined;
    if (isProductSelected && (result.ruleId == null)) {
        return { status: RateFinderResultStatus.NotFound };
    }

    if (result.rate == null) {
        const hasResult = (result.locationId != null) || (result.ruleId != null);
        return { status: hasResult ? RateFinderResultStatus.Partial : RateFinderResultStatus.Empty };
    }
    else {
        return {
            status: RateFinderResultStatus.Found, 
            rate: result.rate
        }
    }            
}

export const reducer = combineReducers({
    criteria,
    result
});